import type { Resource } from '../../';
export const product_details_inStock: Resource = {"default":"In Stock"};
